/**
 * Copyright (c) NCR Terafina
 **/
import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { AnalyticsService } from './AnalyticsService';
/**
 * Render Swagger UI Component
 *
 */
export default function Swagger() {
  AnalyticsService.trackPageView('/swagger', 'Swagger');
  return <SwaggerUI url="openapi.yaml" />;
}
